import Splide from "@splidejs/splide";

const textLinkSliders = document.querySelectorAll(".text_link_carousel");

textLinkSliders.forEach((slider) => {
  const splideSlide = new Splide(slider.querySelector(".splide"), {
    type: "slide",
    trimSpace: false,
    focus: "center",
    perPage: 1,
    gap: "2rem",
    omitEnd: true,
    pagination: false,
    speed: 600,
    easing: "ease",
    mediaQuery: "min",
  });
  splideSlide.mount();

  // Create an element to store current slide when page loads
  const currentSlideInit = splideSlide.root.querySelector(".text-link-current");
  const indexPlusOneInit = splideSlide.index + 1;
  currentSlideInit.innerHTML = indexPlusOneInit.toString();

  // Create a dynamic element to store length of carousel
  const totalSlidesEl = splideSlide.root.querySelector(".text-link-total");
  totalSlidesEl.innerHTML = splideSlide.length.toString();

  // Hide pagination if there is only one slide
  const paginationEl = splideSlide.root.querySelector(".splide__arrows");
  if (splideSlide.length < 2) {
    paginationEl.classList.add("text-link-pagination--hidden");
  }

  // Event listener to change current slide number each time carousel moves
  splideSlide.on("moved", () => {
    const currentSlideEl = splideSlide.root.querySelector(".text-link-current");
    const indexPlusOne = splideSlide.index + 1;
    currentSlideEl.innerHTML = indexPlusOne.toString();
  });
});
